// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-3f90ce7e]:not(.checkout){min-height:calc(100vh - 194px)}.page[data-v-3f90ce7e]{display:flex;flex-wrap:wrap;flex-direction:column}@media(min-width:900px){.page[data-v-3f90ce7e]{flex-direction:row;min-height:calc(100vh - 382px)}}.page.centered-full[data-v-3f90ce7e]{align-items:center;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
